import { resultToFailed, resultToSuccess } from '../Helper'
import stockApi from '../StockApi'

export const getSuppliersQueue = async (fcId, isFresh) => {
  try {
    const result = await stockApi.get('/suppliers/queue', {
      params: { id_fulfillment_center: fcId, is_fresh: isFresh }
    })
    return resultToSuccess(result)
  } catch (e) {
    return resultToFailed(e)
  }
}

export const getSuppliersReceivement = async ({
  fulfillmentCenterId,
  page,
  pageSize
}) => {
  try {
    const result = await stockApi.get('/suppliers/receivements', {
      params: {
        id_fulfillment_center: fulfillmentCenterId,
        page: page,
        per_page: pageSize
      }
    })
    return resultToSuccess(result)
  } catch (e) {
    return resultToFailed(e)
  }
}

export const getSuppliersDocks = async (fcId, isFresh) => {
  try {
    const result = await stockApi.get('/suppliers/receivements/docks', {
      params: { id_fulfillment_center: fcId, is_fresh: isFresh }
    })
    return resultToSuccess(result)
  } catch (e) {
    return resultToFailed(e)
  }
}

export const addSupplierReceivementQueue = async (data, userBarcode) => {
  try {
    const result = await stockApi.post(
      '/v2/queue/supplier/add-to-queue',
      data,
      {
        headers: {
          'Content-Type': 'application/json',
          'user-barcode': userBarcode
        }
      }
    )

    return resultToSuccess(result)
  } catch (e) {
    return resultToFailed(e)
  }
}
